import React from 'react';
import MuiTooltip from '@mui/material/Tooltip';

/**
 * Dense bin grids: keep status tooltips out of the way of neighboring cells.
 * - Show above the bin (default bottom covers the next row)
 * - Delay open so sweeping the mouse across bins does not flash overlays
 * - Non-interactive so the cursor can reach the next bin immediately
 */
const BinTooltip = ({ children, ...props }) => (
  <MuiTooltip
    placement="top"
    enterDelay={650}
    enterNextDelay={400}
    leaveDelay={0}
    disableInteractive
    {...props}
  >
    {children}
  </MuiTooltip>
);

export default BinTooltip;



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/BinTooltip.jsx